import { Quote } from '@lockton-apps/shared/interfaces';
import { createAction, props } from '@ngrx/store';

export enum QuoteOverviewActionsTypes {
  Init = '[Quote Overview Page] Initialised',
  QuoteRemoved = '[Quote Overview Page] Quote Removed',
  ContinueClicked = '[Quote Overview Page] Continue Clicked',
}

export const QuoteOverviewActions = {
  init: createAction(QuoteOverviewActionsTypes.Init),
  quoteRemoved: createAction(
    QuoteOverviewActionsTypes.QuoteRemoved,
    props<{ quote: any }>()
  ),
  continueClicked: createAction(
    QuoteOverviewActionsTypes.ContinueClicked,
    props<{ quotes: Quote[] }>()
  ),
};
